export const FETCH_VEHICLES_REQUEST = "FETCH_VEHICLES_REQUEST"
export const FETCH_VEHICLES_SUCCESS = "FETCH_VEHICLES_SUCCESS"
export const FETCH_VEHICLES_FAILED = "FETCH_VEHICLES_FAILED"



